/**
 * Settings → Security panel.
 *
 * Placeholder for the next iteration. Future work: manage SQL grants
 * (GRANT/REVOKE on tables in the user databases) so admins can wire up
 * data permissions for the editor / reader roles without dropping into
 * SSMS.
 */
import { Alert, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

export function SecurityPanel() {
  return (
    <Stack gap="md">
      <Alert icon={<IconInfoCircle size={16} />} variant="light" color="gray">
        Coming soon — SQL-level grant management.
      </Alert>
      <Text size="sm" c="dimmed">
        Group membership for the three app roles (Admins / Editors / Readers)
        is managed in the <strong>Access control</strong> tab. Granting those
        groups the actual SQL permissions on user databases is currently done
        directly in the database via <code>GRANT</code> statements; future
        versions of this page will let you do it from here.
      </Text>
    </Stack>
  );
}
